import {
  AFrameComponent,
  BarrelComponent,
  DogWalkComponent,
  HoopComponent,
  LongJumpComponent,
  NonWingedDoubleJumpComponent,
  NonWingedOneJumpComponent,
  NonWingedSingleJumpComponent,
  NonWingedTripleJumpComponent,
  ObstacleComponent,
  PanelJumpComponent,
  TableComponent,
  TeeterComponent,
  TireJumpComponent,
  TunnelComponent,
  WallJumpComponent,
  WeavePolesComponent,
  WingedDoubleJumpComponent,
  WingedOneJumpComponent,
  WingedSingleJumpComponent,
  WingedTripleJumpComponent,
} from './components/obstacle/obstacle.component';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  IonAccordion,
  IonAccordionGroup,
  IonAvatar,
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonDatetime,
  IonFab,
  IonFabButton,
  IonFabList,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuButton,
  IonMenuToggle,
  IonPopover,
  IonProgressBar,
  IonRadio,
  IonRadioGroup,
  IonRange,
  IonRouterLink,
  IonRouterLinkWithHref,
  IonRouterOutlet,
  IonRow,
  IonSearchbar,
  IonSegment,
  IonSegmentButton,
  IonSegmentContent,
  IonSegmentView,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonText,
  IonTextarea,
  IonTitle,
  IonToggle,
  IonToolbar,
} from '@ionic/angular/standalone';
import {
  faAngle90,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDoubleUp,
  faArrows,
  faArrowsH,
  faArrowsV,
  faBalanceScale,
  faBorderAll,
  faBorderOuter,
  faBrowser,
  faCabinetFiling,
  faCaretLeft,
  faCaretRight,
  faChalkboardTeacher,
  faCheckCircle,
  faChevronDoubleDown,
  faChevronDoubleUp,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleDashed,
  faCloudDownload,
  faCloudUpload,
  faCrop,
  faDollarSign,
  faEdit,
  faEllipsisH,
  faEuroSign,
  faExclamationCircle,
  faEye,
  faFileAlt,
  faFilter,
  faHeart,
  faHome,
  faImage,
  faLongArrowLeft,
  faMap,
  faPencil,
  faPoundSign,
  faQuestionCircle,
  faSave,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faSignInAlt,
  faSignOutAlt,
  faSquareFull,
  faStars,
  faStop,
  faSync,
  faSyncAlt,
  faTrashAlt,
  faUndo,
  faUserAlt,
  faWifi,
  faWifiSlash,
  faWindowRestore,
  faYenSign,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faBrightness,
  faBrightnessLow,
  faCirclePlus,
  faTimes,
  faTimesCircle,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebookSquare,
  faTwitterSquare,
} from '@fortawesome/free-brands-svg-icons';

import { AdjustLayoutComponent } from './components/adjust-layout/adjust-layout.component';
import { AlertComponent } from './components/alert/alert.component';
import { BackButtonDirective } from './directives/back-button.directive';
import { CharacterCountComponent } from './components/character-count/character-count.component';
import { CommonModule } from '@angular/common';
import { Container } from './components/container';
import { CrossHairComponent } from './components/cross-hair/cross-hair.component';
import { DragRotateDirective } from './directives/drag-rotate.directive';
import { DraggableObstacleDirective } from './directives/draggable-obstacle.directive';
import { FocusDirective } from './directives/focus.directive';
import { LayoutListItemComponent } from './components/layout-list-item/layout-list-item.component';
import { LayoutViewConfigComponent } from './components/layout-view-config/layout-view-config.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { LocateTouchDirective } from './directives/locate-touch.directive';
import { MapLayoutComponent } from './components/map-layout/map-layout.component';
import { MapListItemComponent } from './components/map-list-item/map-list-item.component';
import { MapResizeModalComponent } from './components/map-resize-modal/map-resize-modal.component';
import { MapThumbnailComponent } from './components/map-thumbnail/map-thumbnail';
import { MastersUpgradeButtonComponent } from './components/masters-upgrade-button/masters-upgrade-button.component';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ObstacleListComponent } from './components/obstacle-list/obstacle-list.component';
import { ObstacleLocationListComponent } from './components/obstacle-location-list.component/obstacle-location-list.component';
import { OriginSelectionComponent } from './components/origin-selection/origin-selection.component';
import { PlaceListItemComponent } from './components/place-list-item/place-list-item.component';
import { PreventDefaultDirective } from './directives/prevent-default.directive';
import { SafePipe } from './pipes/safe.pipe';
import { SeriesListItemComponent } from './components/series-list-item/series-list-item.component';
import { StaticLayoutComponent } from './components/static-layout/static-layout.component';
import { SvgGridDirective } from './directives/svg-grid.directive';
import { TapPressDirective } from './directives/tap-press.directive';
import { TourIonPopoverModule } from 'ngx-ui-tour-ionic';
import { UpgradeCardComponent } from './components/upgrade-card/upgrade-card.component';
import { ViewPrintFormComponent } from './components/view-print-form/view-print-form.component';
import { WaResizeObserver } from '@ng-web-apis/resize-observer';
import { faBullseyePointer } from '@fortawesome/pro-light-svg-icons';
import { faBorderAll as faLightBorderAll } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

@NgModule({
  declarations: [
    AdjustLayoutComponent,
    AFrameComponent,
    AlertComponent,
    BackButtonDirective,
    BarrelComponent,
    CharacterCountComponent,
    Container,
    CrossHairComponent,
    DogWalkComponent,
    DragRotateDirective,
    FocusDirective,
    HoopComponent,
    LayoutListItemComponent,
    LayoutViewConfigComponent,
    ListItemComponent,
    LocateTouchDirective,
    LongJumpComponent,
    MapLayoutComponent,
    MapListItemComponent,
    MapThumbnailComponent,
    MastersUpgradeButtonComponent,
    NonWingedDoubleJumpComponent,
    NonWingedOneJumpComponent,
    NonWingedSingleJumpComponent,
    NonWingedTripleJumpComponent,
    ObstacleComponent,
    ObstacleListComponent,
    ObstacleLocationListComponent,
    OriginSelectionComponent,
    PanelJumpComponent,
    PlaceListItemComponent,
    PreventDefaultDirective,
    SafePipe,
    SeriesListItemComponent,
    StaticLayoutComponent,
    SvgGridDirective,
    TapPressDirective,
    TableComponent,
    TeeterComponent,
    TireJumpComponent,
    TunnelComponent,
    WallJumpComponent,
    WeavePolesComponent,
    UpgradeCardComponent,
    WingedDoubleJumpComponent,
    WingedOneJumpComponent,
    WingedSingleJumpComponent,
    WingedTripleJumpComponent,
    DraggableObstacleDirective,
    ViewPrintFormComponent,
    MapResizeModalComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    WaResizeObserver,
    IonAccordion,
    IonAccordionGroup,
    IonAvatar,
    IonBadge,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonContent,
    IonDatetime,
    IonFab,
    IonFabButton,
    IonFabList,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonImg,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonMenu,
    IonMenuButton,
    IonMenuToggle,
    IonPopover,
    IonProgressBar,
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonRouterLink,
    IonRouterLinkWithHref,
    IonRouterOutlet,
    IonRow,
    IonSearchbar,
    IonSegment,
    IonSegmentButton,
    IonSegmentContent,
    IonSegmentView,
    IonSelect,
    IonSelectOption,
    IonSpinner,
    IonText,
    IonTextarea,
    IonTitle,
    IonToggle,
    IonToolbar,
    TourIonPopoverModule,
  ],
  exports: [
    AdjustLayoutComponent,
    AFrameComponent,
    AlertComponent,
    BackButtonDirective,
    BarrelComponent,
    CharacterCountComponent,
    CommonModule,
    Container,
    CrossHairComponent,
    DogWalkComponent,
    DragRotateDirective,
    FocusDirective,
    FontAwesomeModule,
    FormsModule,
    HoopComponent,
    LayoutListItemComponent,
    LayoutViewConfigComponent,
    ListItemComponent,
    LocateTouchDirective,
    LongJumpComponent,
    MapLayoutComponent,
    MapListItemComponent,
    MapThumbnailComponent,
    MastersUpgradeButtonComponent,
    NonWingedDoubleJumpComponent,
    NonWingedOneJumpComponent,
    NonWingedSingleJumpComponent,
    NonWingedTripleJumpComponent,
    NgSelectModule,
    ObstacleComponent,
    ObstacleListComponent,
    ObstacleLocationListComponent,
    OriginSelectionComponent,
    PanelJumpComponent,
    PlaceListItemComponent,
    PreventDefaultDirective,
    ReactiveFormsModule,
    WaResizeObserver,
    SafePipe,
    StaticLayoutComponent,
    SeriesListItemComponent,
    SvgGridDirective,
    TapPressDirective,
    TableComponent,
    TeeterComponent,
    TireJumpComponent,
    TunnelComponent,
    WeavePolesComponent,
    UpgradeCardComponent,
    ViewPrintFormComponent,
    MapResizeModalComponent,
    WallJumpComponent,
    WingedDoubleJumpComponent,
    WingedOneJumpComponent,
    WingedSingleJumpComponent,
    WingedTripleJumpComponent,
    IonAccordion,
    IonAccordionGroup,
    IonAvatar,
    IonBadge,
    IonButton,
    IonButtons,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonContent,
    IonDatetime,
    IonFab,
    IonFabButton,
    IonFabList,
    IonFooter,
    IonGrid,
    IonHeader,
    IonIcon,
    IonImg,
    IonInput,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonMenu,
    IonMenuButton,
    IonMenuButton,
    IonMenuToggle,
    IonPopover,
    IonProgressBar,
    IonRadio,
    IonRadioGroup,
    IonRange,
    IonRouterLink,
    IonRouterLinkWithHref,
    IonRouterOutlet,
    IonRow,
    IonSearchbar,
    IonSegment,
    IonSegmentButton,
    IonSegmentContent,
    IonSegmentView,
    IonSelect,
    IonSelectOption,
    IonSpinner,
    IonText,
    IonTextarea,
    IonTitle,
    IonToggle,
    IonToolbar,
    TourIonPopoverModule,
    DraggableObstacleDirective,
  ],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faAngle90,
      faAngleDoubleDown,
      faAngleDoubleLeft,
      faAngleDoubleRight,
      faAngleDoubleUp,
      faArrows,
      faArrowsH,
      faArrowsV,
      faBalanceScale,
      faBorderAll,
      faBorderOuter,
      faBrightness,
      faBrightnessLow,
      faBrowser,
      faBullseyePointer,
      faCabinetFiling,
      faCaretLeft,
      faCaretRight,
      faChalkboardTeacher,
      faCheckCircle,
      faChevronDoubleDown,
      faChevronDoubleUp,
      faChevronLeft,
      faChevronRight,
      faCircle,
      faCircleDashed,
      faCirclePlus,
      faCloudDownload,
      faCloudUpload,
      faCrop,
      faDollarSign,
      faEdit,
      faEllipsisH,
      faEuroSign,
      faExclamationCircle,
      faEye,
      faFacebookSquare,
      faFileAlt,
      faFilter,
      faHeart,
      faHome,
      faImage,
      faLightBorderAll,
      faLongArrowLeft,
      faMap,
      faPencil,
      faPlus,
      faPoundSign,
      faQuestionCircle,
      faSave,
      faSearch,
      faSearchMinus,
      faSearchPlus,
      faSignInAlt,
      faSignOutAlt,
      faSquareFull,
      faStars,
      faStop,
      faSync,
      faSyncAlt,
      faTimes,
      faTimesCircle,
      faTrashAlt,
      faTwitterSquare,
      faUndo,
      faUserAlt,
      faWifi,
      faWifiSlash,
      faWindowRestore,
      faYenSign,
    );
  }
}
